import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { useRecoilValue } from "recoil";

import { HOMEPAGE_CONTENT_FEED } from "../../GraphQL/homepage";
import { useUser } from "../../Hooks/useUser";
import { ProContentExperimentState } from "MVVM/State/embeddablePlaylist";
import { usePartnerCsPlaylist } from "./usePartnerCsPlaylist";

const limit = 12;

const HomepageViewModel = () => {
  const { allstarUser } = useUser();
  const startDate = useMemo(
    () => String(new Date(new Date().setMonth(new Date().getMonth() - 12))),
    [],
  );
  const showProContent = useRecoilValue(ProContentExperimentState);
  const personalized = allstarUser.loggedIn;

  const { data: contentFeeds, loading: contentFeedsLoading } = useQuery(
    HOMEPAGE_CONTENT_FEED(personalized),
    {
      variables: {
        limit,
        search: "popular",
        startDate,
      },
      fetchPolicy: "cache-and-network",
    },
  );

  const { clips: prosFeed, loading: prosFeedLoading } = usePartnerCsPlaylist({
    sort: "score",
    age: "7d",
    limit: 60,
    enabled: showProContent,
  });

  const { clips: todayInCs, loading: todayInCsLoading } = usePartnerCsPlaylist({
    sort: "views",
    age: "1d",
    limit: 30,
  });

  return {
    allstarUser,
    contentFeeds,
    contentFeedsLoading,
    prosFeed,
    prosFeedLoading,
    todayInCs,
    todayInCsLoading,
  };
};

export { HomepageViewModel };
